// src/domains/core/dashboard/components/widgets/admin/CodeQualityWidget.tsx

import { Code } from "lucide-react";
import { type FC } from "react";

import { Text, Heading, Card, Button } from "@/components/ui";

import { useWidgetConfig } from "../../../hooks/useWidgetConfig";
import { WIDGET_IDS } from "../../../store/widgetRegistry";
import { WidgetContainer } from "../base";

/**
 * CodeQualityWidget - Quick Access zu Code Quality Analysis
 *
 * NOTE: Code Quality Daten-Loading wird in zukünftiger Version implementiert
 *
 * @returns {JSX.Element} Code quality widget component
 *
 */
export const CodeQualityWidget: FC = () => {
  const { config } = useWidgetConfig(WIDGET_IDS.CODE_QUALITY);

  // NOTE: Code Quality Hook wird in zukünftiger Version implementiert
  const loading = false;
  const totalIssues = 0;

  return (
    <WidgetContainer
      description="Analysis summary"
      icon={<Code className="w-5 h-5" />}
      loading={loading}
      size={config?.size ?? "small"}
      title="Code Quality"
      widgetId={WIDGET_IDS.CODE_QUALITY}
    >
      <div className="space-y-3">
        <Card className="text-center" padding="sm" variant="default">
          <Text className="text-xs text-gray-400 mb-1">Total Issues</Text>
          <Heading className="text-xl font-bold text-white" level={4}>
            {totalIssues}
          </Heading>
        </Card>

        <Button className="w-full" disabled size="sm" variant="outline">
          Feature Removed
        </Button>
      </div>
    </WidgetContainer>
  );
};
